import useGetApi from 'src/api/useGetApi';

interface ConfigValueResponse {
  value: unknown;
  createdAt: string;
  updatedAt: string;
}

interface UseOrderfulEdiConfigValueParams {
  type: 'customer' | 'organization';
  customerId?: string;
  key?: string;
}

const useOrderfulEdiConfigValue = ({
  type,
  customerId,
  key,
}: UseOrderfulEdiConfigValueParams) => {
  const endpoint =
    type === 'organization'
      ? `erp-integrations/orderful-edi/config-organization/${encodeURIComponent(
          key || '',
        )}`
      : `erp-integrations/orderful-edi/config-customer/${customerId}/${encodeURIComponent(
          key || '',
        )}`;

  return useGetApi<ConfigValueResponse>({
    endpoint,
    options: {
      enabled:
        !!key &&
        (type === 'organization' || (type === 'customer' && !!customerId)),
    },
  });
};

export default useOrderfulEdiConfigValue;
